<template>
    <div class="bg-a-gray-f7f7f7" data-cy="container_history_delivery_address">
        <div class="text-a-black-000926 text-12 leading-normal px-8 py-5">
            <div class="font-medium" data-cy="text_history_delivery_address_name">
                {{lbl.history.delivery.address}}
                {{serialModel.firstName}} {{serialModel.lastName}}
            </div>
            <div data-cy="text_history_delivery_address_detail">{{serialModel.address}} {{serialModel.zipcode}}</div>
            <div data-cy="text_history_delivery_mobile">
                {{lbl.history.delivery.mobile_number}}
                {{FilterPhoneFormat(serialModel.contactNumber)}}
            </div>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "DeliveryAddress",
    mixins: [LocaleMixin],
    props: {
        serialModel: Object,
    },
    created: function(){
        console.log('this.serialModel', this.serialModel)
    },
    methods: {
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
</style>
